import React from 'react';

export type Props = {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
};

const Warning: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#62339C',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8686 0.431201C19.3754 0.720751 19.7953 1.14069 20.0849 1.64741L34.0634 26.1099C34.959 27.6772 34.4145 29.6738 32.8472 30.5694C32.3534 30.8516 31.7944 31 31.2256 31H3.26845C1.46334 31 0 29.5367 0 27.7315C0 27.1627 0.148438 26.6038 0.430641 26.1099L14.4092 1.64741C15.3048 0.0801252 17.3014 -0.464388 18.8686 0.431201ZM17.1594 20.8364C15.9921 20.8364 15.1166 21.6993 15.1166 22.8498C15.1166 24.0526 15.9655 24.9154 17.1594 24.9154C18.3267 24.9154 19.2022 24.0526 19.2022 22.8759C19.2022 21.6993 18.3267 20.8364 17.1594 20.8364ZM18.7936 8.17113H15.5252V17.9765H18.7936V8.17113Z"
        fill={color}
      />
    </svg>
  );
};

export default Warning;
